/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Audit_Details_Pattern_Created_NamedInputs */



/**
* | output |
* | --- |
* | "The custom pattern \"{name}\" was created and is monitoring requests." |
*
* @param {Audit_Details_Pattern_Created_NamedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_pattern_created_named = /** @type {((inputs: Audit_Details_Pattern_Created_NamedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Pattern_Created_NamedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Das eigene Muster "${i?.name}" wurde erstellt und prüft jetzt Anfragen.`)
	return /** @type {LocalizedString} */ (`The custom pattern "${i?.name}" was created and is monitoring requests.`)
});